import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainers(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/fetch_containers/${agro_exporter_process_id}`
    );
  },
  fetchExportations(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/fetch_exportations/${agro_exporter_process_id}`
    );
  },
  downloadExportationsContainersRepXlsx(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/exportations_containers_rep_xlsx/${agro_exporter_process_id}`,
      { responseType: "blob", foo: "boo" }
    );
  }
};
